import React from 'react';

export const gotoLogin = () => {
  // Extract the fpr query parameter from the URL
  const searchParams = new URLSearchParams(window.location.search);
  const finalFpr = searchParams.get('fpr') || 'neuroflashoriginal';

  window.open(`https://app.neuroflash.com/register?fpr=${finalFpr}`, '_blank');
};



export const handleCopy = (text: string) => {
  console.log('Copy action for:', text);
  navigator.clipboard.writeText(text);
};


export const handlePerformance = (text: string) => {
  console.log('Performance action for:', text);
  // To Be Implemented
};

export const handleDelete = (
  index: number,
  responses: string[],
  setResponses: React.Dispatch<React.SetStateAction<string[]>>
) => {
  const updatedResponses = responses.filter((_, i) => i !== index);
  setResponses(updatedResponses);

};

export const countWords = (text: string): number => {
  return text.trim().split(/\s+/).length;
};


export const handlePaste = async (setInputText: (text: string) => void) => {
  try {
    const text = await navigator.clipboard.readText(); // Get copied text
    setInputText(text); // Paste into input field
  } catch (err) {
    console.error('Failed to read clipboard contents:', err);
  }
};
